(function () {
  'use strict';
  var tip = document.getElementById('ttg-cart-tip');
  if (!tip) return;
  var timer, dismissed = false;
  function trigger() { return document.getElementById('cart-icon-bubble'); }
  function position() {
    var link = trigger();
    if (!link || tip.hidden) return;
    var r = link.getBoundingClientRect();
    tip.style.left = Math.max(12, Math.min(r.right - tip.offsetWidth, innerWidth - tip.offsetWidth - 12)) + 'px';
    tip.style.top = Math.max(12, Math.min(r.bottom + 10, innerHeight - tip.offsetHeight - 12)) + 'px';
  }
  function show() {
    clearTimeout(timer);
    var link = trigger();
    if (!link || dismissed) return;
    tip.hidden = false;
    var ids = (link.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(tip.id) < 0) ids.push(tip.id);
    link.setAttribute('aria-describedby', ids.join(' '));
    position();
  }
  function hide() {
    clearTimeout(timer); tip.hidden = true;
    var link = trigger();
    if (!link) return;
    var ids = (link.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== tip.id; });
    if (ids.length) link.setAttribute('aria-describedby', ids.join(' '));
    else link.removeAttribute('aria-describedby');
  }
  function scheduleHide() { clearTimeout(timer); timer = setTimeout(function () { var link=trigger(); if (!tip.matches(':hover') && !(link && (link.matches(':hover') || link === document.activeElement))) hide(); }, 180); }
  document.addEventListener('pointerover', function (e) {
    var link=e.target.closest && e.target.closest('#cart-icon-bubble');
    if (link && e.pointerType !== 'touch' && !(e.relatedTarget && link.contains(e.relatedTarget))) { dismissed=false; show(); }
  });
  document.addEventListener('pointerout', function (e) {
    var link=e.target.closest && e.target.closest('#cart-icon-bubble');
    if (link && !(e.relatedTarget && link.contains(e.relatedTarget))) { dismissed=false; scheduleHide(); }
  });
  document.addEventListener('focusin', function (e) { if (e.target.id === 'cart-icon-bubble' && e.target.matches(':focus-visible')) { dismissed=false; show(); } });
  document.addEventListener('focusout', function (e) { if (e.target.id === 'cart-icon-bubble') { dismissed=false; scheduleHide(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !tip.hidden) { dismissed=true; hide(); } });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#cart-icon-bubble')) hide(); });
  tip.addEventListener('pointerenter', function () { clearTimeout(timer); });
  tip.addEventListener('pointerleave', scheduleHide);
  window.addEventListener('resize', position);
  window.addEventListener('scroll', hide, {passive:true});
})();
